import {Pipe, PipeTransform} from '@angular/core';
import {GraphNodeModel} from "./models/graph-node.model";
import {EntityTypes} from "web-shared";

@Pipe({
  name: 'nodeColor'
})
export class NodeColorPipe implements PipeTransform {

  transform(node: GraphNodeModel, mode: 'bg' | 'text'): unknown {
    return mode === 'text' ? this.getTextColor(node) : this.getColor(node);
  }

  getColor(node: GraphNodeModel) {
    if (node.Color) {
      return node.Color;
    }
    switch (node.type) {
      case EntityTypes.MasterInputInstruction:
        return node.Color = '#ceeffb';
      case EntityTypes.MasterUseInstruction:
        return node.Color = '#b2eddb';
      case EntityTypes.MasterOperation:
        return node.Color = '#ff4514';
      case EntityTypes.Item:
        return node.Color = '#ff9800';
      case EntityTypes.Resource:
        return node.Color = '#2196f3';
      case EntityTypes.Material:
        return node.Color = '#00b862';
      case EntityTypes.MasterOutputInstruction:
        return node.Color = '#ff9800';
      case EntityTypes.General:
        return node.Color = '#a7b61a';
      case EntityTypes.IntermediateItem:
        return node.Color = '#3f51b5';
      case EntityTypes.ItemGroup:
        return node.Color = '#dcdcdc';
      case EntityTypes.ProcessSelector:
      case EntityTypes.TaskSelector:
        return node.Color = '#a8dadc';
      default:
        return node.Color = '#FFFFFF';
    }
  }

  getTextColor(node: GraphNodeModel) {
    return this.getContrast(node.Color ?? '#FFFFFF');
  }

  /*!
 * Get the contrasting color for any hex color
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */
  getContrast(hexColor) {

    // If a leading # is provided, remove it
    if (hexColor.slice(0, 1) === '#') {
      hexColor = hexColor.slice(1);
    }

    // If a three-character hexcode, make six-character
    if (hexColor.length === 3) {
      hexColor = hexColor.split('').map(function (hex) {
        return hex + hex;
      }).join('');
    }

    // Convert to RGB value
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);

    // Get YIQ ratio
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    // Check contrast
    return (yiq >= 150) ? 'black' : 'white';
  };
}
